import {
  DollarOutlined,
  HomeOutlined,
  MenuOutlined,
  QrcodeOutlined,
  ShoppingOutlined,
} from "@ant-design/icons";
import React, { useState } from "react";

import { Drawer } from "@material-ui/core";
import QRScanner from "./QRScanner";
import SideMenu from "./SideMenu";
import { TabBar } from "antd-mobile";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const MobileTabBar = ({ nftSection, challengesSection }) => {
  const [open, setOpen] = useState(false);
  const [drawer, setDrawer] = useState(false);
  const [dataQR, setDataQR] = useState("");
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    console.log(dataQR);
  }, [dataQR]);

  const setRouteActive = (value) => {
    if (value === " ") return;
    else if (value === "/more") setDrawer(true);
    else value === "" ? handleOpenModal() : window.scroll({ top: value, behavior: "smooth" });
  };

  const handleOpenModal = () => setOpen(true);

  const tabs = [
    {
      key: 0,
      title: "Inicio",
      icon: <HomeOutlined />,
    },
    {
      key: challengesSection?.current?.offsetTop,
      title: "Ganar",
      icon: <DollarOutlined />,
    },
    {
      key: " ",
      title: " ",
      icon: "",
    },
    {
      key: "",
      title: "",
      icon: <QrcodeOutlined className="qr_svg" />,
    },
    {
      key: nftSection?.current?.offsetTop,
      title: "Tienda",
      icon: <ShoppingOutlined />,
    },
    {
      key: "/more",
      title: "Más",
      icon: <MenuOutlined />,
    },
  ];

  return (
    <>
      <TabBar
        activeKey={pathname}
        onChange={(value) => setRouteActive(value)}
        style={styles.tabBar}
      >
        {tabs.map((item) => (
          <TabBar.Item
            key={item.key}
            icon={item.icon}
            title={item.title}
            className={item.title === "" ? "qr_item" : item.title === " " && "false_item"}
          />
        ))}
      </TabBar>

      <QRScanner onScanQR={open} setOnScanQR={setOpen} setData={setDataQR} />

      <Drawer open={drawer} onClose={() => setDrawer(false)} anchor="right">
        <SideMenu nftSection={nftSection} challengesSection={challengesSection} />
      </Drawer>
    </>
  );
};

export default MobileTabBar;

const styles = {
  tabBar: {
    width: "100%",
    backgroundColor: "white",
    padding: "16px 0",
    borderRadius: "25px 25px 0 0",
    filter: "drop-shadow(0 0 12px grey)",
    userSelect: "none",
  },
};
